export class DashboardProductBestSellingFilter {
  categories?: string[];
  limit?: number;
  startDate?: string;
  endDate?: string;
}
